import { EmailAlertsApi } from './email-alerts-api';
import { EmailAlertsTooltip } from './email-alerts-tooltip';
import { TooltipWidget } from 'www/modules/tooltip/tooltip-widget'
import { EmailAlertsLayer } from './email-alerts-layer'
import { distinctUntilChanged, map } from 'rxjs/operators';
import { EmailAlertsTracking } from './email-alerts-tracking';
import { DATA_TYPES, FEEDBACK_TYPES } from './email-alerts-constants';

let emailAlertsApi = null;
let emailAlertsLayer = null;
let _EmailAlertsTracking = null;


class EmailAlertsWidget extends TooltipWidget {
    constructor() {
        super(EmailAlertsTooltip);
        this._labelContainer = null;
        this._iconContainer = null;

    }
    init() {
        super.init();
        this.tooltipLayer.api = this.api;
        this.tooltipLayer.init();
        this.initSubscriptions();
        this.emailAlertsLayer.init();
    }
    get TooltipLayer(){
        return EmailAlertsTooltip;
    }
    initSubscriptions() {
        this.api.state
            .pipe(distinctUntilChanged(null, state => {
                return state.isVisible;
            }))
            .subscribe(state => {
                if (state.isVisible) {
                    this.el.style.display = "";
                } else {
                    this.el.style.display = "none";
                }
            })
        this.onClick.subscribe(e => {
            window.showModal("palertadexcontainer");
            this.api.addSubscription().then(data => {
                const { subscriptionFeedback } = data;
                this.handleAddSubscriptionFeedback(subscriptionFeedback);
            });
        })

        this.api.state
            .pipe(distinctUntilChanged(null, state => {
                return state.isSubscribed;
            }))
            .subscribe(state => {
                this.handleSubscriptionUpdate(state.isSubscribed);
            })

        this.api.state.pipe(
            map(state => {
                return {
                    topicName: state.conceptName || state.sectionName
                }
            }),
            distinctUntilChanged(null, state => {
                return state.topicName;
            })).subscribe(state => {
            this.emailAlertsLayer.api.setTopic(state.topicName);
        })
    }
    get api() {
        if (emailAlertsApi == null) {
            emailAlertsApi = new EmailAlertsApi();
        }
        return emailAlertsApi;
    }

    get breakpoint(){
        return window.breakpoint;
    }
    get emailAlertsLayer() {
        if (emailAlertsLayer == null) {
            emailAlertsLayer = new EmailAlertsLayer();
        }
        return emailAlertsLayer;
    }
    get labelText() {
        const locale = window.locale || 'en';
        let labelText = "";

        if (this.api.state.isSubscribed) {
            labelText = "Added to Email Alerts";
        } else {
            labelText = "Add to Email Alerts";
        }

        return labelText.toUpperCase();
    }
    get tracking() {
        if (_EmailAlertsTracking == null) {
            _EmailAlertsTracking = new EmailAlertsTracking(this.api);
        }
        return _EmailAlertsTracking;
    }


    handleAddSubscriptionFeedback(subscriptionFeedback = "") {

        const isSubscribed = subscriptionFeedback == FEEDBACK_TYPES.NEW || subscriptionFeedback == FEEDBACK_TYPES.EXISTING || subscriptionFeedback == FEEDBACK_TYPES.SUCCESS;
        this.api.setSubscribed(isSubscribed);
        if (isSubscribed) {
            this.emailAlertsLayer.api.show();
            if (this.api.dataType == DATA_TYPES.CONCEPT) {
                this.tracking.addConceptSubscription(subscriptionFeedback);
            } else if (this.api.dataType == DATA_TYPES.SECTION) {
                this.tracking.addSectionSubscriptino(subscriptionFeedback);
            }
        }

    }
    handleSubscriptionUpdate(isSubscribed = this.api.state.isSubscribed) {
        if (isSubscribed) {
            this.tooltipApi.disableLayer();
        } else {
            this.tooltipApi.enableLayer();
        }
    }


}

export { EmailAlertsWidget }